import React from "react";
import { withRouter } from "react-router-dom";
import {
  RichiestaTipo,
  RichiestaStato,
  createCriteriInvioModel,
  createProdottoRichiestoModel,
} from "../../../domain/richieste";
import {
  dosaggiMock,
  formeFarmaceuticheMock,
} from "../../../mocks/farmaci/farmaci.mock";
import FarmaciService from "../../../services/FarmaciService";
import RichiesteService from "../../../services/RichiesteService";
import AuthService from "../../../services/AuthService";
import UserProfileService from "../../../services/UserProfileService";
import UserService from "../../../services/UserService";
import MarketplaceProductsSection from "../../../components/DashboardMarketplace/MarketplaceProductsSection";
import MarketplaceCartSection from "../../../components/DashboardMarketplace/MarketplaceCartSection";
import "../../../styles/screens/marketplace/dashboard/DashboardMarketPlace.css";

const MARKETPLACE_STORAGE_KEY = "marketplace.dashboard";

class DashboardMarketPlace extends React.Component {
  constructor(props) {
    super(props);

    const persistedState = this.getPersistedState();
    this.hasPersistedState = Boolean(persistedState);

    this.state = {
      tipo: persistedState?.tipo || this.getTypeFromLocation(props.location.search),
      criteriInvio: persistedState?.criteriInvio
        ? { ...createCriteriInvioModel(), ...persistedState.criteriInvio }
        : createCriteriInvioModel(),
      indirizzoRiferimento: persistedState?.indirizzoRiferimento || "Via Torino 18, Milano",
      coordinateRiferimento: persistedState?.coordinateRiferimento || null,
      ricercaFarmaco: persistedState?.ricercaFarmaco || "",
      filtroFormaFarmaceutica: persistedState?.filtroFormaFarmaceutica || "",
      filtroDosaggio: persistedState?.filtroDosaggio || "",
      mostraSuggerimentiFarmaci: false,
      showAdvancedFilters: persistedState?.showAdvancedFilters || false,
      farmaciCatalogo: [],
      prodotti: Array.isArray(persistedState?.prodotti) ? persistedState.prodotti : [],
      noteUtente: persistedState?.noteUtente || "",
      checkoutMode: persistedState?.checkoutMode || (UserService.isLoggedIn() ? "login" : "register"),
      registrationData: {
        firstName: persistedState?.registrationData?.firstName || "",
        lastName: persistedState?.registrationData?.lastName || "",
        email: persistedState?.registrationData?.email || "",
        codiceFiscale: persistedState?.registrationData?.codiceFiscale || "",
        address: persistedState?.registrationData?.address || "",
        password: "",
      },
      isRegistering: false,
      registrationError: "",
      registrationSuccess: "",
      isSubmitting: false,
      submitError: "",
      submitSuccess: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (UserService.isLoggedIn() && !this.hasPersistedState) {
      this.loadCurrentUserProfile();
    }
    this.loadFarmaci();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      const tipo = this.getTypeFromLocation(this.props.location.search);
      if (tipo !== this.state.tipo) {
        this.setState({ tipo });
        return;
      }
    }

    if (prevState !== this.state) {
      this.persistMarketplaceState();
    }
  }

  getPersistedState = () => {
    if (typeof window === "undefined") {
      return null;
    }

    try {
      const rawState = window.sessionStorage.getItem(MARKETPLACE_STORAGE_KEY);
      return rawState ? JSON.parse(rawState) : null;
    } catch (error) {
      return null;
    }
  };

  persistMarketplaceState = () => {
    if (typeof window === "undefined") {
      return;
    }

    const snapshot = {
      tipo: this.state.tipo,
      criteriInvio: this.state.criteriInvio,
      indirizzoRiferimento: this.state.indirizzoRiferimento,
      coordinateRiferimento: this.state.coordinateRiferimento,
      ricercaFarmaco: this.state.ricercaFarmaco,
      filtroFormaFarmaceutica: this.state.filtroFormaFarmaceutica,
      filtroDosaggio: this.state.filtroDosaggio,
      showAdvancedFilters: this.state.showAdvancedFilters,
      prodotti: this.state.prodotti,
      noteUtente: this.state.noteUtente,
      checkoutMode: this.state.checkoutMode,
      registrationData: this.state.registrationData,
    };

    window.sessionStorage.setItem(MARKETPLACE_STORAGE_KEY, JSON.stringify(snapshot));
  };

  clearPersistedState = () => {
    if (typeof window === "undefined") {
      return;
    }

    window.sessionStorage.removeItem(MARKETPLACE_STORAGE_KEY);
  };

  getTypeFromLocation = (search) => {
    const params = new URLSearchParams(search);
    const tipo = params.get("tipo");
    return tipo === "servizi" ? "servizi" : "prodotti";
  };

  normalizeFarmaco = (farmaco, index = 0) => ({
    ...farmaco,
    id: farmaco.id || farmaco._id || `farmaco_${index}`,
    prezzoIndicativo:
      typeof farmaco.prezzoIndicativo === "number"
        ? farmaco.prezzoIndicativo
        : this.getFarmacoEstimatedPrice(farmaco, index),
  });

  normalizeSeller = (seller, index = 0) => ({
    ...seller,
    id: seller.id || seller._id || `seller_${index}`,
  });

  getFarmacoEstimatedPrice = (farmaco = {}, index = 0) => {
    const seedSource = `${farmaco.id || farmaco._id || index}-${farmaco.nome || ""}-${farmaco.dosaggio || ""}`;
    const hash = seedSource
      .split("")
      .reduce((accumulator, char) => accumulator + char.charCodeAt(0), 0);
    const basePrice = 4 + (hash % 18);
    const cents = [0.49, 0.79, 0.99][hash % 3];

    return Number((basePrice + cents).toFixed(2));
  };

  onNoteChange = (event) => {
    this.setState({ noteUtente: event.target.value });
  };

  getFarmacoLabel = (farmaco) =>
    `${farmaco.nome} - ${farmaco.formaFarmaceutica} - ${farmaco.dosaggio}`;

  getFarmacoImageSrc = (farmaco) => {
    const fallback =
      "data:image/svg+xml;utf8," +
      encodeURIComponent(
        "<svg xmlns='http://www.w3.org/2000/svg' width='96' height='96'>" +
          "<rect width='100%' height='100%' fill='#eef2f7'/>" +
          "<text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#6b7280' font-size='11' font-family='Arial'>Farmaco</text>" +
        "</svg>"
      );
    if (farmaco.immagineUrl) {
      return farmaco.immagineUrl;
    }
    if (farmaco.immagine) {
      return farmaco.immagine;
    }
    return fallback;
  };

  getFilteredFarmaci = () => {
    const searchTerm = this.state.ricercaFarmaco.trim().toLowerCase();
    const forma = this.state.filtroFormaFarmaceutica.trim().toLowerCase();
    const dosaggio = this.state.filtroDosaggio.trim().toLowerCase();

    return this.state.farmaciCatalogo.filter((farmaco) => {
      const nome = (farmaco.nome || "").toLowerCase();
      const label = this.getFarmacoLabel(farmaco).toLowerCase();
      const formaFarmaco = (farmaco.formaFarmaceutica || "").trim().toLowerCase();
      const dosaggioFarmaco = (farmaco.dosaggio || "").trim().toLowerCase();

      const matchesSearch =
        searchTerm.length === 0 ||
        nome.includes(searchTerm) ||
        label.includes(searchTerm);
      const matchesForma = !forma || formaFarmaco === forma;
      const matchesDosaggio = !dosaggio || dosaggioFarmaco === dosaggio;

      return matchesSearch && matchesForma && matchesDosaggio;
    });
  };

  getFormeFarmaceuticheOptions = () => {
    const dynamic = Array.from(
      new Set(
        this.state.farmaciCatalogo
          .map((farmaco) => farmaco.formaFarmaceutica)
          .filter(Boolean)
      )
    ).sort();
    return dynamic.length > 0 ? dynamic : formeFarmaceuticheMock;
  };

  getDosaggiOptions = () => {
    const dynamic = Array.from(
      new Set(this.state.farmaciCatalogo.map((farmaco) => farmaco.dosaggio).filter(Boolean))
    ).sort();
    return dynamic.length > 0 ? dynamic : dosaggiMock;
  };

  shouldShowFarmaciSuggestions = () => {
    const hasSearch = this.state.ricercaFarmaco.trim().length > 0;
    return (
      this.state.mostraSuggerimentiFarmaci &&
      hasSearch &&
      this.getFilteredFarmaci().length > 0
    );
  };

  onFarmacoSearchChange = (event) => {
    this.setState(
      {
        ricercaFarmaco: event.target.value,
        mostraSuggerimentiFarmaci: true,
      },
      this.loadFarmaci
    );
  };

  onFarmacoSearchFocus = () => {
    this.setState({ mostraSuggerimentiFarmaci: true });
  };

  onFarmacoSearchBlur = () => {
    window.setTimeout(() => {
      this.setState({ mostraSuggerimentiFarmaci: false });
    }, 150);
  };

  toggleAdvancedFilters = () => {
    this.setState((prevState) => ({
      showAdvancedFilters: !prevState.showAdvancedFilters,
    }));
  };

  onFarmacoFilterChange = (field, value) => {
    this.setState(
      {
        [field]: value,
        mostraSuggerimentiFarmaci: true,
      },
      this.loadFarmaci
    );
  };

  addFarmacoToRichiesta = (farmaco) => {
    const productName = this.getFarmacoLabel(farmaco);
    const existingProduct = this.state.prodotti.find(
      (prodotto) => prodotto.nome === productName
    );

    if (existingProduct) {
      this.setState((prevState) => ({
        prodotti: prevState.prodotti.map((prodotto) =>
          prodotto.nome === productName
            ? { ...prodotto, quantita: prodotto.quantita + 1 }
            : prodotto
        ),
      }));
      return;
    }

    this.setState((prevState) => ({
      prodotti: [
        ...prevState.prodotti,
        createProdottoRichiestoModel({
          id: `prd_${prevState.prodotti.length + 1}`,
          nome: productName,
          quantita: 1,
          prezzoIndicativo: Number(farmaco.prezzoIndicativo || 0),
          equivalenteConsentito: false,
        }),
      ],
      ricercaFarmaco: "",
      mostraSuggerimentiFarmaci: false,
    }));
  };

  isFarmacoSelected = (farmaco) =>
    this.state.prodotti.some(
      (prodotto) => prodotto.nome === this.getFarmacoLabel(farmaco)
    );

  onProductChange = (index, field, value) => {
    const prodotti = [...this.state.prodotti];
    prodotti[index] = {
      ...prodotti[index],
      [field]: value,
    };
    this.setState({ prodotti });
  };

  removeProductRow = (index) => {
    this.setState((prevState) => ({
      prodotti: prevState.prodotti.filter((_, currentIndex) => currentIndex !== index),
    }));
  };

  isRegistrationComplete = () => {
    const { firstName, lastName, email, codiceFiscale, address } = this.state.registrationData;
    return Boolean(firstName && lastName && email && codiceFiscale && address);
  };

  canShowSubmitRichiesta = () =>
    this.state.prodotti.length > 0 && UserService.isLoggedIn();

  getProdottiTotaleStimato = () =>
    this.state.prodotti.reduce(
      (total, prodotto) =>
        total + (Number(prodotto.prezzoIndicativo) || 0) * Math.max(Number(prodotto.quantita) || 0, 0),
      0
    );

  onCheckoutModeChange = (checkoutMode) => {
    this.setState({
      checkoutMode,
      submitError: "",
      submitSuccess: "",
      registrationError: "",
      registrationSuccess: "",
    });
  };

  onRegistrationFieldChange = (field, value) => {
    this.setState(
      (prevState) => ({
        registrationData: {
          ...prevState.registrationData,
          [field]: field === "codiceFiscale" ? value.toUpperCase() : value,
        },
        registrationError: "",
        registrationSuccess: "",
        indirizzoRiferimento:
          field === "address" ? value : prevState.indirizzoRiferimento,
        coordinateRiferimento:
          field === "address" ? null : prevState.coordinateRiferimento,
      }),
      
    );
  };

  onLogin = () => {
    this.persistMarketplaceState();
    UserService.startPortalLogin("customer");
  };

  onRegister = async () => {
    const { firstName, lastName, email, codiceFiscale, address, password } = this.state.registrationData;

    if (!firstName || !lastName || !email || !codiceFiscale || !address || !password) {
      this.setState({
        registrationError: "Compila Nome, Cognome, Email, Codice fiscale, Indirizzo e Password per registrarti.",
        registrationSuccess: "",
      });
      return;
    }

    this.setState({
      isRegistering: true,
      registrationError: "",
      registrationSuccess: "",
    });

    try {
      const response = await AuthService.register({
        firstName,
        lastName,
        email,
        codiceFiscale,
        address,
        password,
      });

      this.persistMarketplaceState();
      this.setState({
        isRegistering: false,
        registrationSuccess:
          response?.message ||
          "Registrazione completata. Verifica la tua email prima di accedere.",
        registrationError: "",
        checkoutMode: "login",
      });
    } catch (error) {
      this.setState({
        isRegistering: false,
        registrationError:
          error?.response?.data?.detail || "Registrazione non riuscita. Riprova tra poco.",
        registrationSuccess: "",
      });
    }
  };

  loadFarmaci = async () => {
    try {
      const response = await FarmaciService.list({
        q: this.state.ricercaFarmaco || undefined,
      });

      this.setState({
        farmaciCatalogo: (response.items || []).map(this.normalizeFarmaco),
      });
    } catch (error) {
      this.setState({
        farmaciCatalogo: [],
      });
    }
  };

  loadCurrentUserProfile = async () => {
    if (!UserService.isLoggedIn()) {
      return;
    }

    try {
      const profile = await UserProfileService.getMe();
      const preferredReference =
        profile.accountType === "SELLER" && profile.sellerAddress
          ? profile.sellerAddress
          : profile.preferredLocation;

      if (!preferredReference) {
        return;
      }

      
    } catch (error) {
      // Keep default reference.
    }
  };

  


  getRegistrationSummary = () => this.state.noteUtente;

  buildCustomerSnapshot = () => {
    const parsed = UserService.getParsedToken() || {};
    const firstName = this.state.registrationData.firstName || parsed.given_name || "";
    const lastName = this.state.registrationData.lastName || parsed.family_name || "";
    const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();

    return {
      firstName,
      lastName,
      fullName: fullName || parsed.name || "",
      email: this.state.registrationData.email || parsed.email || "",
      address: this.state.registrationData.address || this.state.indirizzoRiferimento || "",
      userId: parsed.preferred_username || parsed.email || parsed.sub || "",
    };
  };

  getCheckoutError = () => {
    if (UserService.isLoggedIn()) {
      return "";
    }

    return "Accedi o registrati con il tuo account per continuare con l'invio.";
  };

  buildRichiestaTitle = () => {
    if (this.state.prodotti.length === 0) {
      return "Ordine marketplace";
    }

    const firstName = this.state.prodotti[0]?.nome || "Prodotto";
    return this.state.prodotti.length === 1
      ? `Ordine ${firstName}`
      : `Ordine ${firstName} +${this.state.prodotti.length - 1}`;
  };

  buildRichiestaPayload = () => {
    //const recipientIds = this.getAutomaticRecipientIds();

    return {
      codice: `RQ-${Date.now()}`,
      tipo: RichiestaTipo.PRODOTTI,
      titolo: this.buildRichiestaTitle(),
      stato: RichiestaStato.INVIATA,
      utenteId: "",
      noteUtente: this.getRegistrationSummary(),
      customerSnapshot: this.buildCustomerSnapshot(),
      criteriInvio: {
        ...this.state.criteriInvio,
      },
      prodotti: this.state.prodotti,
      servizio: null,
    };
  };

  onSubmitRichiesta = async () => {
    //const recipientIds = this.getAutomaticRecipientIds();

    if (this.state.prodotti.length === 0) {
      this.setState({
        submitError: "Aggiungi almeno un prodotto prima di inviare la richiesta.",
        submitSuccess: "",
      });
      return;
    }

    const checkoutError = this.getCheckoutError();
    if (checkoutError) {
      this.setState({
        submitError: checkoutError,
        submitSuccess: "",
      });
      return;
    }

    /*if (recipientIds.length === 0) {
      this.setState({
        submitError: "Nessun venditore compatibile trovato per l'indirizzo indicato.",
        submitSuccess: "",
      });
      return;
    }*/

    this.setState({
      isSubmitting: true,
      submitError: "",
      submitSuccess: "",
    });

    try {
      const richiesta = await RichiesteService.create(this.buildRichiestaPayload());
      this.clearPersistedState();
      this.hasPersistedState = false;
      this.setState({
        isSubmitting: false,
        submitSuccess: `Richiesta ${richiesta.codice} inviata correttamente al marketplace.`,
        submitError: "",
        prodotti: [],
        noteUtente: "",
        checkoutMode: "login",
      });
    } catch (error) {
      this.setState({
        isSubmitting: false,
        submitError: "Invio richiesta non riuscito. Riprova tra poco.",
        submitSuccess: "",
      });
    }
  };

  renderFarmacoSuggestionCard = (farmaco) => {
    const isSelected = this.isFarmacoSelected(farmaco);

    return (
      <button
        type="button"
        key={farmaco.id}
        className={`dashboard-marketplace-suggestion-card ${isSelected ? "is-selected" : ""}`}
        onMouseDown={() => this.addFarmacoToRichiesta(farmaco)}
      >
        <div className="dashboard-marketplace-suggestion-card__header">
          <div className="dashboard-marketplace-suggestion-card__main">
            <div className="dashboard-marketplace-suggestion-card__image">
              <img
                src={this.getFarmacoImageSrc(farmaco)}
                alt={farmaco.nome}
                loading="lazy"
                referrerPolicy="no-referrer"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = this.getFarmacoImageSrc({});
                }}
              />
            </div>
            <div>
              <span className="badge badge-info-light">{farmaco.formaFarmaceutica}</span>
              <h5>{farmaco.nome}</h5>
              <p>{farmaco.dosaggio}</p>
            </div>
          </div>
          <span className={`dashboard-marketplace-suggestion-card__cta ${isSelected ? "is-selected" : ""}`}>
            {isSelected ? "Aggiungi ancora" : "Aggiungi"}
          </span>
        </div>
        <div className="dashboard-marketplace-suggestion-card__body">
          <div className="dashboard-marketplace-suggestion-card__price">
            da EUR {Number(farmaco.prezzoIndicativo || 0).toFixed(2)}
          </div>
          <div className="dashboard-marketplace-suggestion-card__meta">
            <span>
              <i className="fa fa-clock-o m-r-5"></i>
              Disponibilita rapida
            </span>
            <span>
              <i className="fa fa-check-circle m-r-5"></i>
              Pronto per il marketplace
            </span>
          </div>
          <div className="dashboard-marketplace-suggestion-card__footer">
            <span className="badge badge-light">Risultato ricerca</span>
            {isSelected ? (
              <span className="badge badge-success">Gia nel carrello</span>
            ) : (
              <span className="badge badge-primary">Tap per aggiungere</span>
            )}
          </div>
        </div>
      </button>
    );
  };

  render() {
    const filteredFarmaci = this.getFilteredFarmaci();

    return (
      <div
        className="dashboard-marketplace-page"
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12">
              <MarketplaceProductsSection
                submitError={this.state.submitError}
                submitSuccess={this.state.submitSuccess}
                ricercaFarmaco={this.state.ricercaFarmaco}
                onFarmacoSearchChange={this.onFarmacoSearchChange}
                onFarmacoSearchFocus={this.onFarmacoSearchFocus}
                onFarmacoSearchBlur={this.onFarmacoSearchBlur}
                showAdvancedFilters={this.state.showAdvancedFilters}
                toggleAdvancedFilters={this.toggleAdvancedFilters}
                filtroFormaFarmaceutica={this.state.filtroFormaFarmaceutica}
                filtroDosaggio={this.state.filtroDosaggio}
                onFarmacoFilterChange={this.onFarmacoFilterChange}
                formeFarmaceutiche={this.getFormeFarmaceuticheOptions()}
                dosaggi={this.getDosaggiOptions()}
                filteredFarmaci={filteredFarmaci}
                shouldShowFarmaciSuggestions={this.shouldShowFarmaciSuggestions()}
                renderFarmacoSuggestionCard={this.renderFarmacoSuggestionCard}
              />
              <MarketplaceCartSection
                prodotti={this.state.prodotti}
                totaleStimato={this.getProdottiTotaleStimato()}
                noteUtente={this.state.noteUtente}
                onNoteChange={this.onNoteChange}
                onProductChange={this.onProductChange}
                removeProductRow={this.removeProductRow}
                checkoutMode={this.state.checkoutMode}
                onCheckoutModeChange={this.onCheckoutModeChange}
                isAuthenticated={UserService.isLoggedIn()}
                onLogin={this.onLogin}
                onRegister={this.onRegister}
                registrationData={this.state.registrationData}
                onRegistrationFieldChange={this.onRegistrationFieldChange}
                canShowSubmit={this.canShowSubmitRichiesta()}
                isRegistering={this.state.isRegistering}
                registrationError={this.state.registrationError}
                registrationSuccess={this.state.registrationSuccess}
                isSubmitting={this.state.isSubmitting}
                submitError={this.state.submitError}
                submitSuccess={this.state.submitSuccess}
                onLogout={UserService.doLogout}
                onSubmitRichiesta={this.onSubmitRichiesta}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DashboardMarketPlace);
















